enum LocalStorageKey {
  BITMOVIN_LOGIN = 'bitmovin_login'
}

interface BitmovinLoginData {
  readonly apiKey: string;
}

class LocalStorageService {
  private constructor() {}

  public static storeLogin(loginData: BitmovinLoginData) {
    const expires = new Date(new Date().getTime() + 864000 * 1000).getTime();

    const bitmovinLogin = {
      expires,
      ...loginData
    };

    try {
      window.localStorage.setItem(LocalStorageKey.BITMOVIN_LOGIN, JSON.stringify(bitmovinLogin));
    } catch (e) {
      // not important
    }
  }

  public static removeLogin() {
    window.localStorage.removeItem(LocalStorageKey.BITMOVIN_LOGIN);
  }

  public static getLogin(): BitmovinLoginData {
    let bitmovinLogin: any = window.localStorage.getItem(LocalStorageKey.BITMOVIN_LOGIN);
    if (!bitmovinLogin) {
      return undefined;
    }

    try {
      bitmovinLogin = JSON.parse(bitmovinLogin);
    } catch (syntaxError) {
      return undefined;
    }

    if (bitmovinLogin.expires < new Date().getTime()) {
      return undefined;
    }

    return bitmovinLogin;
  }
}

export default LocalStorageService;
